export default __webpack_public_path__ + "static/media/book_9.1919e604.svg";